import React from 'react';
import { SvgIcon } from '@mui/material';

const PulseIcon = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            {/* Pulse/heartbeat line */}
            <path
                d="M2 12h3l2-4 2 8 2-6 2 4h9"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Circle representing community/membership */}
            <circle
                cx="18"
                cy="8"
                r="3"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
            />
            {/* Small dots representing members */}
            <circle cx="16" cy="6" r="0.8" fill="currentColor" />
            <circle cx="18" cy="6.5" r="0.8" fill="currentColor" />
            <circle cx="20" cy="6" r="0.8" fill="currentColor" />
        </SvgIcon>
    );
};

export default PulseIcon;
